export function toLiteWhiteboardSnapshot(source) {
  if (!source || typeof source !== "object") return null;

  const elements = Array.isArray(source.elements) ? source.elements : [];
  if (!elements.length) return null;

  return {
    version: Number(source.version || 1),
    elements,
    pageCount: Math.max(1, Math.min(100, Number(source.pageCount || 1))),
    updatedAt: Number(source.updatedAt || Date.now()),
    updatedBy: source.updatedBy || "snapshot",
  };
}

export function toLiteWhiteboards(sources) {
  return Array.isArray(sources)
    ? sources.map((source) => toLiteWhiteboardSnapshot(source))
    : [];
}
